module.exports = __webpack_public_path__ + "img/Weapon_bow_01_Arrow.8ecba062.png";